/**
 * Meetings API service
 */

import api from './api.service';

export type MeetingStatus = 'in_progress' | 'completed' | 'abandoned';

export interface MeetingListItem {
  roomCode: string;
  templateId: number;
  templateTitle: string;
  templateVersion: number;
  status: MeetingStatus;
  createdAt: string;
  endedAt?: string;
  completionPercentage: number;
  totalFields: number;
  filledFields: number;
  ownerId: number;
  ownerName: string;
}

export interface MeetingListResponse {
  meetings: MeetingListItem[];
  total: number;
}

export interface MeetingFilters {
  templateId?: number;
  status?: MeetingStatus;
  from?: string;
  to?: string;
  ownerId?: number;
}

export interface MeetingDeleteResponse {
  success: boolean;
  message: string;
}

export const meetingsApi = {
  /**
   * Get meetings for current user
   */
  getMyMeetings: async (filters?: MeetingFilters): Promise<MeetingListResponse> => {
    const params = new URLSearchParams();
    if (filters?.templateId) params.append('template_id', filters.templateId.toString());
    if (filters?.status) params.append('status', filters.status);
    if (filters?.from) params.append('from', filters.from);
    if (filters?.to) params.append('to', filters.to);

    const queryString = params.toString();
    const url = `/api/meetings${queryString ? `?${queryString}` : ''}`;

    const { data } = await api.get<MeetingListResponse>(url);
    return data;
  },

  /**
   * Get all meetings (admin only)
   */
  getAllMeetings: async (filters?: MeetingFilters): Promise<MeetingListResponse> => {
    const params = new URLSearchParams();
    if (filters?.templateId) params.append('template_id', filters.templateId.toString());
    if (filters?.ownerId) params.append('owner_id', filters.ownerId.toString());
    if (filters?.status) params.append('status', filters.status);
    if (filters?.from) params.append('from', filters.from);
    if (filters?.to) params.append('to', filters.to);

    const queryString = params.toString();
    const url = `/api/meetings/all${queryString ? `?${queryString}` : ''}`;

    const { data } = await api.get<MeetingListResponse>(url);
    return data;
  },

  /**
   * Delete a meeting
   */
  deleteMeeting: async (roomCode: string): Promise<MeetingDeleteResponse> => {
    const { data } = await api.delete<MeetingDeleteResponse>(`/api/meetings/${roomCode}`);
    return data;
  },
};

export default meetingsApi;
